const config = {
	api: 'http://localhost:6200',
	appPath: '/',
	loginTimeout: 18000000
};

export default config;